import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { useRootStore } from 'core/hooks/use-root-store';
import { TgAuthStore } from './tg-auth.store';

const TgAuthContext = React.createContext<TgAuthStore | null>(null);

export const TgAuthProvider = ({ children }: { children: ReactNode }) => {
   const rootStore = useRootStore();
   const { i18n } = useTranslation('global');

   const selectedLanguage = Cookies.get('selectedLanguage') || i18n.language || 'ukr';
   const apiLanguage = selectedLanguage === 'ukr' ? 'uk' : selectedLanguage;

   const [store] = React.useState<TgAuthStore>(() => new TgAuthStore(rootStore, apiLanguage));

   return <TgAuthContext.Provider value={store}>{children}</TgAuthContext.Provider>;
};

export const useTgAuth = (): TgAuthStore => {
   const ctx = React.useContext(TgAuthContext);
   if (!ctx) {
      throw new Error('useTgAuth must be used inside TgAuthProvider');
   }
   return ctx;
};
